import { render } from "./AdminPannel.vue?vue&type=template&id=88e5f120&scoped=true"
import script from "./AdminPannel.vue?vue&type=script&lang=js"
export * from "./AdminPannel.vue?vue&type=script&lang=js"

import "./AdminPannel.vue?vue&type=style&index=0&id=88e5f120&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88e5f120"]])

export default __exports__